import React from "react";
import DropdownMultiSelect from "./DropdownMultiSelect";

function ItemsSelector({ items, enable, onSave, fields, values, name, error, col = 6 }) {
  const getOptionLabel = (o) => fields.map((f) => o[f]).filter(Boolean).join(", ");

  return (
    <div className={`col-md-${col}`}>
      <label className="form-label fw-medium mb-1">{name}</label>
      {error && <div className="form-error small mb-1">{error}</div>}
      <DropdownMultiSelect
        options={items}
        value={values}
        onChange={onSave}
        getOptionLabel={getOptionLabel}
        getOptionValue={(o) => o.id}
        placeholder={`Select ${name.toLowerCase()}…`}
        disabled={!enable}
        className={error ? "is-invalid" : ""}
      />
    </div>
  );
}

export default ItemsSelector;
